import styled, { keyframes } from 'styled-components';

const CheckmarkAnimation = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

interface SuccessIconProps {
  width?: string;
  height?: string;
  afterWidth?: string;
  afterHeight?: string;
}

export const SuccessIcon = styled.div<SuccessIconProps>`
  width: ${({ width }) => width ?? '80px'};
  height: ${({ height }) => height ?? '80px'};
  border-radius: 50%;
  background-color: #10b981;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  animation: ${CheckmarkAnimation} 0.6s ease-in-out;

  &::after {
    content: '';
    display: block;
    width: ${({afterWidth}) => afterWidth ?? '30px'};
    height: ${({afterHeight}) => afterHeight ?? '30px'};
    border: solid white;
    border-width: 0 0 3px 3px;
    transform: rotate(-45deg);
    margin-top: -5px;
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;

    &::after {
      width: 20px;
      height: 10px;
    }
  }
`;
